import { render, staticRenderFns } from "./SiteInfo.vue?vue&type=template&id=b6b34f3a&"
import script from "./SiteInfo.vue?vue&type=script&lang=ts&"
export * from "./SiteInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports